import {useEffect} from "react";
import * as React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {BaseCard} from "../../Components/Cards/BaseCard";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faDownload} from "@fortawesome/free-solid-svg-icons";
import {useBoundStore} from "../../Store/store";
import {TextInputReadOnly} from "../../Components/Form/TextInputReadOnly";
import {isMyCcpSubdomain} from "../../Utils/SubdomainHelper";

export const CustomerContractDetail = () => {
    const {contractId} = useParams();
    const navigate = useNavigate();
    const {t} = useTranslation();

    const getContractDetail = useBoundStore((state) => state.getContractDetail);
    const contractDetail = useBoundStore((state) => state.contractDetail);

    useEffect(() => {
        getContractDetail(contractId);
    }, [getContractDetail, contractId]);

    return (
        <div>
            <div className={'flex flex-row justify-between mb-4 items-center'}>
                <div>
                    <h1 className={'text-2xl font-semibold'}>{t('general.labels.contract_details')}</h1>
                    <div className={"flex flex-row group items-center"} onClick={() => navigate('/customer/contracts')}>
                        <FontAwesomeIcon icon={faArrowLeft} className={'text-sm transition-all group-hover:mr-2 duration-500 cursor-pointer'}/>
                        <div className={'text-sm text-gray-500 my-auto cursor-pointer ml-2'}>{t('general.actions.back_to_overview')}</div>
                    </div>
                </div>
            </div>
            <BaseCard border={false}>
                <h2 className={'text-lg text-gray-700 uppercase mb-1 mt-2'}>{t('general.labels.contract_information')}</h2>
                <div className={'grid grid-cols-1 md:grid-cols-2 gap-4'}>
                    <TextInputReadOnly
                        name={'contract_number'}
                        translationIndex={'general.fields.contract_number'}
                        value={contractDetail.id}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'status'}
                        translationIndex={t('general.fields.status')}
                        value={contractDetail.status}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'document_number'}
                        translationIndex={t('general.fields.document_number')}
                        value={contractDetail.documenso_id}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'customer'}
                        translationIndex={t('general.fields.customer')}
                        value={`${contractDetail.branch?.contact_firstname} ${contractDetail.branch?.contact_lastname}`}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'customer_email'}
                        translationIndex={t('general.fields.customer_email')}
                        value={contractDetail.branch?.contact_email}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'customer_tel'}
                        translationIndex={t('general.fields.customer_tel')}
                        value={contractDetail.branch?.contact_tel}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'freelancer'}
                        translationIndex={t('general.fields.freelancer')}
                        value={`${contractDetail.freelancer?.branches?.[0]?.contact_firstname} ${contractDetail.freelancer?.branches?.[0]?.contact_lastname}`}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'freelancer_email'}
                        translationIndex={t('general.fields.freelancer_email')}
                        value={contractDetail.freelancer?.branches?.[0]?.contact_email}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'freelancer_tel'}
                        translationIndex={t('general.fields.freelancer_tel')}
                        value={contractDetail.freelancer?.branches?.[0]?.contact_tel ?? (contractDetail?.freelancer?.tel ?? '-')}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'freelancer_hourly_rate'}
                        translationIndex={t('general.fields.freelancer_hourly_rate')}
                        value={contractDetail.freelancer?.hourly_rate !== undefined && contractDetail.freelancer?.hourly_rate !== null
                            ? Number(isMyCcpSubdomain() ? contractDetail.freelancer.hourly_rate : contractDetail.freelancer.hourly_rate * 1.18).toFixed(2).replace('.', ',')
                            : ''}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'freelancer_company'}
                        translationIndex={t('general.fields.freelancer_company')}
                        value={contractDetail.freelancer?.branches?.[0]?.company_name}
                        disabled
                    />
                    <TextInputReadOnly
                        name={'freelancer_vat_number'}
                        translationIndex={t('general.fields.freelancer_vat_number')}
                        value={contractDetail.freelancer?.branches?.[0]?.vat_number}
                        disabled
                    />
                </div>
                <div className={'mt-4'}>
                    {contractDetail.document && (
                        <div className={'flex flex-row space-x-4'}>
                            <FontAwesomeIcon icon={faDownload} className={'text-primary cursor-pointer'} onClick={() => window.open(contractDetail.document.url, '_blank')}/>
                            <span>{contractDetail.document.fileName}</span>
                        </div>
                    )}
                </div>
            </BaseCard>
        </div>
    );
}
